export function sanitizeHTML(html: string): string {
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
}

export function safeDecodeHtmlEntities(text: string): string {
  if (!text) {
    return text ?? '';
  }

  const withoutTags = text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const doc = new DOMParser().parseFromString(withoutTags, 'text/html');
  return doc.documentElement.textContent || '';
}
